(function() {
  var StepController, TruthStripToolbar,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepController = App.loadClass('grower::Angular/Data/PlantingRx/StepController');

  TruthStripToolbar = App.loadClass('grower::classes/data/planting_rx/TruthStripToolbar');

  exports.TruthStripsController = (function(superClass) {
    extend(TruthStripsController, superClass);

    function TruthStripsController(scope, transitions, map, visualLayers, layerManager, toolbar, loader) {
      var load_msg;
      this.scope = scope;
      this.transitions = transitions;
      this.map = map;
      this.visualLayers = visualLayers;
      this.layerManager = layerManager;
      this.toolbar = toolbar;
      this.loader = loader;
      this.syncAreas = bind(this.syncAreas, this);
      this.deleteArea = bind(this.deleteArea, this);
      this.createTruthStrip = bind(this.createTruthStrip, this);
      this.disableTruthStrips = bind(this.disableTruthStrips, this);
      this.enableTruthStrips = bind(this.enableTruthStrips, this);
      this.getCombinedLayers = bind(this.getCombinedLayers, this);
      TruthStripsController.__super__.constructor.call(this, this.scope, this.transitions, this.map);
      if (this.scope.aborted) {
        return;
      }
      this.scope.enableTruthStrips = this.enableTruthStrips;
      this.scope.disableTruthStrips = this.disableTruthStrips;
      this.scope.createTruthStrip = this.createTruthStrip;
      this.scope.toolbar_mode = this.toolbar.getMode;
      this.scope.toolbar = this.toolbar;
      this.scope.deleteArea = this.deleteArea;
      this.pre_strips = this.scope.rx.truth_strips.slice();
      this.scope.$watch('toolbar.areas', this.syncAreas);
      this.setUpMap();
      load_msg = this.loader.overMapAndSidebar('Loading...');
      if ((this.scope.rx.cross_crop_operations_id != null) && _.isEqual(this.scope.rx.visual_layers, this.scope.rx.previous_visual_layers)) {
        this.getCombinedLayers(load_msg);
      } else {
        this.visualLayers.combineLayers(this.scope.rx.fields_id, this.scope.rx.visual_layers).then((function(_this) {
          return function(result) {
            _this.scope.rx.previous_visual_layers = _.clone(_this.scope.rx.visual_layers);
            _this.scope.rx.cross_crop_operations_id = result.cross_crop_operations_id;
            return _this.getCombinedLayers(load_msg);
          };
        })(this))["catch"]((function(_this) {
          return function() {
            return load_msg.hide();
          };
        })(this));
      }
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.toolbar.hide();
        };
      })(this));
    }

    TruthStripsController.prototype.getCombinedLayers = function(load_msg) {
      return this.layerManager.get('CombinedLayers').display({
        layers: this.scope.rx.visual_layers,
        field_id: this.scope.rx.fields_id,
        cross_crop_operations_id: this.scope.rx.cross_crop_operations_id
      }, this.mapLayer).then((function(_this) {
        return function() {
          if (_this.scope.rx.want_truth_strips) {
            _this.toolbar.areas = _this.pre_strips;
            return _this.toolbar.show();
          }
        };
      })(this))["finally"]((function(_this) {
        return function() {
          return load_msg.hide();
        };
      })(this));
    };

    TruthStripsController.prototype.enableTruthStrips = function() {
      if (this.scope.rx.want_truth_strips) {
        return;
      }
      this.scope.rx.want_truth_strips = true;
      this.syncAreas(this.toolbar.areas);
      return this.toolbar.show();
    };

    TruthStripsController.prototype.disableTruthStrips = function() {
      this.scope.rx.want_truth_strips = false;
      this.scope.$parent.setValidity(true);
      if (this.scope.rx.truth_strips.length > 0) {
        this.scope.rx.truth_strips = [];
      }
      return this.toolbar.hide();
    };

    TruthStripsController.prototype.createTruthStrip = function() {
      return this.toolbar.newStrip();
    };

    TruthStripsController.prototype.deleteArea = function(area) {
      return this.toolbar.deleteArea(area);
    };

    TruthStripsController.prototype.syncAreas = function(areas) {
      var i, index, len, ref, ref1, results, strip;
      if (((ref = this.toolbar.toolbar) != null ? ref.drawControl : void 0) != null) {
        this.toolbar.toolbar.drawControl.deselectAllButtons();
      }
      if (areas.length === 0 && this.scope.rx.want_truth_strips) {
        this.scope.$parent.setValidity(false);
      } else {
        this.scope.$parent.setValidity(true);
      }
      this.scope.rx.truth_strips = areas;
      ref1 = this.scope.rx.truth_strips;
      results = [];
      for (index = i = 0, len = ref1.length; i < len; index = ++i) {
        strip = ref1[index];
        results.push(strip.strip_id = index);
      }
      return results;
    };

    return TruthStripsController;

  })(StepController);

}).call(this);
